var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconService2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_27985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8323 16.3107C25.1579 16.3107 29.4752 14.3919 29.4752 12.025C29.4752 9.65804 25.1579 7.73926 19.8323 7.73926C14.5067 7.73926 10.1895 9.65804 10.1895 12.025C10.1895 14.3919 14.5067 16.3107 19.8323 16.3107Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1895 12.0254V24.8825C10.1895 27.2397 14.4752 29.1682 19.8323 29.1682C25.1895 29.1682 29.4752 27.2397 29.4752 24.8825V12.0254",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4752 18.4531C29.4752 20.8103 25.1895 22.7388 19.8323 22.7388C14.4752 22.7388 10.1895 20.8103 10.1895 18.4531",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6182 3.45366C17.1142 1.90839 14.1996 1.16105 11.261 1.3108C5.92531 1.3108 1.61816 3.23937 1.61816 5.59651C1.61816 6.8608 2.86102 7.99651 4.83245 8.8108",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83245 21.6681C2.86102 20.8538 1.61816 19.7181 1.61816 18.4538V5.59668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83245 15.2397C2.86102 14.4254 1.61816 13.2897 1.61816 12.0254",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_27985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.546875 0.239258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconService2);
export default __webpack_public_path__ + "static/media/icon-service-2.90a8697763a0c0b2210d31a088890848.svg";
export { ForwardRef as ReactComponent };